const FROM_INTRO4_SESSION_KEY = "experience_from_intro4";

/** Call before navigating from intro4 (theme selection) to home. */
export function setNavigatingFromIntro4ToHome(): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(FROM_INTRO4_SESSION_KEY, "1");
  } catch {
    // ignore quota / private mode
  }
}

/**
 * Returns true once if the user just arrived on home from intro4, then clears the flag.
 */
export function consumeHideHomeChromeFromIntro4(): boolean {
  if (typeof sessionStorage === "undefined") return false;
  try {
    if (sessionStorage.getItem(FROM_INTRO4_SESSION_KEY) !== "1") return false;
    sessionStorage.removeItem(FROM_INTRO4_SESSION_KEY);
    return true;
  } catch {
    return false;
  }
}
